import DropdownMenu from "@/common/components/DropdownMenu";
import { EllipsisVerticalIcon } from "lucide-react";
import { useState } from "react";
import { DashboardData } from "../../types/dashboards/dashboard.type";
import DeleteDashboard from "./DeleteDashboard";
import UpdateDashboard from "./UpdateDashboard";
import UpdateDashboardVisibility from "./UpdateDashboardVisibility";

interface DashboardHeaderProps {
  dashboard: DashboardData;
  dashboardUpdatedAt: number;
  isCreator: boolean;
  hasPermissionToUpdateDashboard: boolean;
  onDeleteDashboard: () => void;
}

const DashboardHeader = ({
  dashboard,
  dashboardUpdatedAt,
  isCreator,
  hasPermissionToUpdateDashboard,
  onDeleteDashboard,
}: DashboardHeaderProps) => {
  const [updateModalIsOpen, setUpdateModalIsOpen] = useState(false);
  const [updateVisibilityModalIsOpen, setUpdateVisibilityModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-start">
        <div className="flex items-center gap-1">
          <p className="text-lg font-bold overflow-hidden text-nowrap max-w-72 overflow-ellipsis">
            {dashboard.display_name}
          </p>

          {isCreator && (
            <DropdownMenu
              triggerClassName="bg-transparent hover:bg-white-100 disabled:hover:bg-transparent transition-colors px-1.5 py-1.5 -m-1.5 ml-auto"
              triggerLabel=""
              TriggerIcon={<EllipsisVerticalIcon size={16} strokeWidth={1.5} />}
              menuPositionAlign="start"
              options={[
                {
                  label: "Editar",
                  onClick: () => setUpdateModalIsOpen(true),
                  disabled: !hasPermissionToUpdateDashboard,
                  tooltipMessage: !hasPermissionToUpdateDashboard ? 'Você não tem permissão' : undefined,
                },
                {
                  label: "Alterar visibilidade",
                  onClick: () => setUpdateVisibilityModalIsOpen(true),
                  disabled: !hasPermissionToUpdateDashboard,
                  tooltipMessage: !hasPermissionToUpdateDashboard ? 'Você não tem permissão' : undefined,
                },
                {
                  label: "Deletar",
                  onClick: () => setDeleteModalIsOpen(true),
                  className: '*:text-danger-soft hover:*:text-danger-soft/80',
                  operationKlassToCheckPermission: 'Client::Dashboards::Destroy',
                },
              ]}
            />
          )}
        </div>
      </div>

      <UpdateDashboard
        dashboard={dashboard}
        dashboardUpdatedAt={dashboardUpdatedAt}
        isOpen={updateModalIsOpen}
        setIsOpen={setUpdateModalIsOpen}
      />

      <UpdateDashboardVisibility
        dashboard={dashboard}
        isOpen={updateVisibilityModalIsOpen}
        setIsOpen={setUpdateVisibilityModalIsOpen}
      />

      <DeleteDashboard
        dashboardId={dashboard.id}
        isOpen={deleteModalIsOpen}
        setIsOpen={setDeleteModalIsOpen}
        onDeleteDashboard={onDeleteDashboard}
      />
    </>
  );
}

export default DashboardHeader;
